import { render, staticRenderFns } from "./ResourceDelivery.vue?vue&type=template&id=46446d0a&scoped=true"
import script from "./ResourceDelivery.vue?vue&type=script&lang=js"
export * from "./ResourceDelivery.vue?vue&type=script&lang=js"
import style0 from "./ResourceDelivery.vue?vue&type=style&index=0&id=46446d0a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46446d0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46446d0a')) {
      api.createRecord('46446d0a', component.options)
    } else {
      api.reload('46446d0a', component.options)
    }
    module.hot.accept("./ResourceDelivery.vue?vue&type=template&id=46446d0a&scoped=true", function () {
      api.rerender('46446d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billManage/billList/components/ResourceDelivery.vue"
export default component.exports